import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import 'rxjs/add/observable/of';
import { Observable } from 'rxjs/Observable';
import { environment } from '../../../environments/environment';
import { LogLevel } from './log-level.enum';
import { LogEntry } from './log.service';

export abstract class LogPublisher {
  location: string;
  abstract log(record: LogEntry, url: String): Observable<boolean>;
  clear(): Observable<boolean> {
    console.clear();
    localStorage.removeItem(this.location);
    return Observable.of(true);
  }

  postToAPI(location, entry, http) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };
    delete entry['logActivity'];
    delete entry['logErr'];
    delete entry['logFieldHistory'];
    http.post(location, entry, httpOptions).subscribe(() => { },
      (err: HttpErrorResponse) => {
        if (err.error instanceof Error) {
          console.log('Client-side error occured.');
        } else {
          console.log('Server-side error occured.');
        }
      }
    );
  }
}

export class LogConsole extends LogPublisher {
  log(entry: LogEntry, url: String): Observable<boolean> {
    const logLevel = LogLevel[entry.level];
    const message = JSON.stringify(entry);
    switch (logLevel) {
      case LogLevel.Warn:
        console.warn(message);
        break;
      case LogLevel.Error:
        console.error(message);
        break;
      default:
        console.log(message);
        break;
    }
    return Observable.of(true);
  }

  clear(): Observable<boolean> {
    return super.clear();
  }
}

export class LogLocalStorage extends LogPublisher {

  constructor() {
    super();
    // Set location
    this.location = '$$MyApp-Log-Id$$';
  }

  // Append log entry to local storage
  log(entry: LogEntry, url: String): Observable<boolean> {
    let ret = false;
    let values: LogEntry[];
    try {
      // Get previous values from local storage
      values = JSON.parse(localStorage.getItem(this.location)) || [];
      values.push(entry);
      // Store array into local storage
      localStorage.setItem(this.location, JSON.stringify(values));
      // Set return value
      ret = true;
    } catch (ex) {
      // Display error in console
      console.log(ex);
    }
    return Observable.of(ret);
  }

  // Clear all log entries from local storage
  clear(): Observable<boolean> {
    return super.clear();
  }
}

export class LogWebApi extends LogPublisher {

  constructor(
    private http: HttpClient,
    private loggerLocation) {
    super();
  }

  // Add log entry to back end data store
  log(entry: LogEntry, url: String): Observable<boolean> {
    if (entry['logErr'] || entry['logFieldHistory']) {
      if (url !== '' && url !== undefined && url !== null) {
        this.location = url + this.loggerLocation;
      } else {
        this.location = environment.masterUrl + this.loggerLocation;
      }
      super.postToAPI(this.location, entry, this.http);
    }
    return Observable.of(true);
  }

  clear(): Observable<boolean> {
    return super.clear();
  }
}

export class LogAuditApi extends LogPublisher {

  constructor(private http: HttpClient, private loggerLocation) {
    super();
    // this.location = URL.CLIENT_LOG;
  }
  // Add log entry to back end data store
  log(entry: LogEntry, url: String): Observable<boolean> {
    if (entry['logActivity']) {
      if (url !== '' && url !== undefined && url !== null) {
        this.location = url + this.loggerLocation;
      } else {
        this.location = environment.masterUrl + this.loggerLocation;
      }
      super.postToAPI(this.location, entry, this.http);
    }
    return Observable.of(true);
  }

  clear(): Observable<boolean> {
    return super.clear();
  }
}

/* export class LogFieldHistoryApi extends LogPublisher {

  constructor(private http: HttpClient, private loggerLocation) {
    super();
  }

  // Add log entry to back end data store
  log(entry: LogEntry, url: String): Observable<boolean> {
    if (entry['logFieldHistory']) {
      if (url !== '' && url !== undefined && url !== null) {
        this.location = url + this.loggerLocation;
      } else {
        this.location = environment.masterUrl + this.loggerLocation;
      }
      super.postToAPI(this.location, entry, this.http);
    }
    return Observable.of(true);
  }

  clear(): Observable<boolean> {
    return super.clear();
  }
} */



// WEBPACK FOOTER //
// ./src/app/services/shared/log-publishers.ts